import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens(store, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("carrinho", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        return resp;
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Store(store, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "carrinho",
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        return resp.data;
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  // async Delete(store, params) {
  //   const headers = Helpers.iniciarRequisicao();
  //   return await api
  //     .delete("carrinho/" + params.id, {
  //       headers,
  //       data: params
  //     })
  //     .then(resp => {
  //       localStorage.setItem("token", resp.data.token);
  //     })
  //     .catch(() => {
  //       // Helpers.logout();
  //     });
  // },
  async atualizarPedidoGrupo(store, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "car_atualizar_pedido_grupo",
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        return resp.data;
      })
      .catch(() => {
        // Helpers.logout();
      });
  }
};
